module.exports = __webpack_public_path__ + "static/media/icon_messenger.1b6463ad.svg";